module.exports = __webpack_public_path__ + "img/codeQr.f4c6263b.png";